import { render, staticRenderFns } from "./PagePasswordReset.vue?vue&type=template&id=65e828ca&scoped=true&"
import script from "./PagePasswordReset.vue?vue&type=script&lang=js&"
export * from "./PagePasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e828ca",
  null
  
)

export default component.exports